import * as React from "react";
import styled from "@mui/material/styles/styled";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

//region [[ Styles ]]

const StrengthCircularIndicatorView = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

const StrengthLabel = styled(Typography)(({ theme }) => ({
  color: KahunColorMap.DefaultLight,
  position: "absolute",
  top: "13px",
  width: "50px",
  textAlign: "center",

  [theme.breakpoints.down(MobileView)]: {
    color: "white",
  },
}));

const CircularProgressFront = styled(CircularProgress)(({ theme }) => ({
  fontSize: "16px",
  color: KahunColorMap.Secondary,

  [theme.breakpoints.down(MobileView)]: {
    fontSize: "13px",
    color: "white",
  },
}));

const CircularProgressBack = styled(CircularProgress)(({ theme }) => ({
  fontSize: "16px",
  color: KahunColorMap.Secondary,

  position: "absolute",
  top: "0px",
  left: "0px",
  opacity: 0.3,

  [theme.breakpoints.down(MobileView)]: {
    fontSize: "13px",
    color: "white",
  },
}));

const CircleContainer = styled("div")(({ theme }) => ({
  position: "relative",

  width: "40px",
  height: "50px",
  marginRight: "20px",
}));

const AccuracyLabel = styled("span")(({ theme }) => ({
  fontSize: "16px",
  color: KahunColorMap.DefaultLight,

  [theme.breakpoints.down(MobileView)]: {
    fontSize: "14px",
    color: "white",
  },
}));

function CircularProgressWithLabel(props) {
  return (
    <CircleContainer>
      <CircularProgressBack
        variant="determinate"
        {...props}
        value={100}
        size={50}
      />
      <StrengthLabel>{Math.round(props.value * 10) / 10}</StrengthLabel>
      <CircularProgressFront
        variant="determinate"
        {...props}
        size={50}
        value={props.value * 10}
      />
    </CircleContainer>
  );
}

CircularProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

//endregion [[ Styles ]]

//region [[ Props ]]

export interface StrengthCircularIndicatorProps {
  strength: number;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const StrengthCircularIndicator = ({
  ...props
}: StrengthCircularIndicatorProps) => {
  return (
    <StrengthCircularIndicatorView>
      <CircularProgressWithLabel value={props.strength * 10} />
      <AccuracyLabel>Suspicion Index</AccuracyLabel>
    </StrengthCircularIndicatorView>
  );
};
